<style lang="less" scoped>
.htIndex{position: relative;display: flex;flex-direction: column;justify-content:center;align-items:center;margin: 0;padding: 0;background: #fff;font-family: Microsoft YaHei;margin-bottom: 0.25rem;margin:auto;}
.ht-first{display: flex;margin-left: 1rem;margin-top: 0.4rem;
  ul{list-style: none;display: flex;}
  p{margin: 0.32rem 0rem;width: 1.8rem;text-align: left;}
  .mount{color: red;font-weight: 600;}}
.ht-second{
  ul{width: 9rem;margin-left: 1rem;margin-top: -0.12rem; list-style: none;display: flex;flex-wrap: wrap}
  li{margin-top: 0.38rem;width: 1.2rem;margin-right: 0.5rem;}}
img{cursor: pointer;}
</style>

<template>
  <div clss="htIndex">
    <div class="ht-first">
      <div v-if="show2" class="examine">
        <ul>
          <li v-for="(item,index) in picLists" :key="index">
            <img :src="item.pic" @click="goNav(item)" />
          </li>
          <p><span style="margin-left: 0.1rem;">待审核文章</span><span class="mount">{{this.sumCount}}</span><span>篇</span></p>
        </ul>
      </div>
      <div v-if="show3" class="release">
        <ul>
          <li v-for="(item,index) in picListes" :key="index">
            <img :src="item.pic" @click="goNav(item)" />
          </li>
          <p><span style="margin-left: 0.1rem;">待发布文章</span><span class="mount">{{this.sumCounts}}</span><span>篇</span></p>
        </ul>
      </div>
    </div>
      
      <div v-if="show1" class="ht-second">
        <ul>
          <li v-for="(item,index) in picList" :key="index">
            <img :src="item.pic" @click="goNav(item)" />
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
/**
 * 何宽 后台首页
 */
export default {
  data()
  {
    return {
      sumCount: null,
      sumCounts: null,
      weather: null,
      lower: null,
      higher: null,
      show1: false,
      show2: false,
      show3: false,
      picList: [
        {pic: 'static/images/后台管理首页切图/矿业资讯管理.png', path: '/Kyzxgl', id: 19},
        {pic: 'static/images/后台管理首页切图/项目合作管理.png', path: '/Xmhzgl', id: 25},
        {pic: 'static/images/后台管理首页切图/资讯服务管理.png', path: '/Zxfwgl', id: 19},
        {pic: 'static/images/后台管理首页切图/矿业展会管理.png', path: '/Kyzhgl', id: 22},
        {pic: 'static/images/后台管理首页切图/东盟矿产管理.png', path: '/Dmkygl', id: 26},
        {pic: 'static/images/后台管理首页切图/矿产品管理.png',   path: '/Kcpgl', id: 27},
        {pic: 'static/images/后台管理首页切图/珠宝玉石管理.png', path: '/Zbysgl', id: 28},
        {pic: 'static/images/后台管理首页切图/矿业设备管理.png', path: '/Kysbgl', id: 29},
        {pic: 'static/images/后台管理首页切图/矿用药剂管理.png', path: '/Kyyjgl', id: 30},
        {pic: 'static/images/后台管理首页切图/数据共享管理.png', path: '/Sjgxgl', id: 32},
        {pic: 'static/images/后台管理首页切图/资料库管理.png',   path: '/Dxzlgl', id: 31}
      ],
      picLists: [
        {pic: 'static/images/后台管理首页切图/待审核文章.png', path: '/TokyExamine', id: 13}
      ],
      picListes: [
        {pic: 'static/images/后台管理首页切图/待发布文章.png', path: '/ToKyRelease', id: 55}
      ]
    }
  },
  created()
  {
    this.getNumber()
    this.getNumbers()
    this.urlpath = window.location.href
    this.parms = this.urlpath.substring(this.urlpath.lastIndexOf('/') + 1)
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    if ((userInfo.role.indexOf(1) !== -1 || userInfo.role.indexOf(2) !== -1 || userInfo.role.indexOf(3) !== -1) && userInfo.role.indexOf(8) === -1)
    {
      this.show2 = true
      this.show1 = false
      this.show3 = false
    }
    else if ((userInfo.role.indexOf(1) !== -1 || userInfo.role.indexOf(2) !== -1 || userInfo.role.indexOf(3) !== -1) && userInfo.role.indexOf(8) === -1)
    {
      this.show2 = true
      this.show1 = true
      this.show3 = false
    }
    else if (userInfo.role.indexOf(6) !== -1 && userInfo.role.indexOf(8) === -1)
    {
      this.show3 = true
      this.show1 = false
      this.show2 = false
    }
    else if (userInfo.role.indexOf(6) !== -1 && userInfo.role.indexOf(8) !== -1)
    {
      this.show3 = true
      this.show1 = true
      this.show2 = false
    }
    else
    {
      this.show1 = true
      this.show2 = true
      this.show3 = true
    }
  },
  methods: {
    goNav(item)
    {
      this.$store.commit('onNavID', item.id)
      this.$router.push({path: item.path})
    },
    getNumber()
    {
      let exp = ''
      let userInfo = JSON.parse(localStorage.getItem('userMsg'))
      let exaary = userInfo.role.toString()
      if (userInfo.role.indexOf(0) !== -1)
        exp = 'examine in (1, 2, 3)'
      else
        exp = `examine in (${exaary})`
      let paras = {cmd: 'querySQL', _major: 99, _minor: 47,  keyno: 'examineNum', _exp: exp}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length !== 0)
        {
          ret.forEach((data) =>
          {
            this.sumCount += data.count1
          })
        }
      })
    },
    getNumbers()
    {
      let exps = 'examine =5'
      let paras = {cmd: 'querySQL', _major: 99, _minor: 47,  keyno: 'examineNum', _exp: exps}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length !== 0)
          this.sumCounts = ret[0].count1
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/layout/HTIndex.vue